export const URL_PREFIX = '/account/preferences';

export const LOGIN_URL = '/account-login';

export const ACCOUNT_URL = '/account/dashboard';

export const EDIT_EMAIL_URL = `/account/profile/email`;

export const EDIT_ADDRESS_URL = '/account/addresses';

export const ADD_ADDRESS_URL = '/account/addresses/add-address';

export const COMM_PREFS_URL = '/communication-preferences';

export const TEXTS_URL = '/communication-preferences/texts';

export const PHARMACY_TEXTS_URL = '/communication-preferences/texts/pharmacy-text-alerts';

export const EXTRACARE_TEXTS_URL = '/communication-preferences/texts/extracare-text-alerts';

export const CAREMARK_TEXTS_URL = '/communication-preferences/texts/caremark-text-alerts';

export const SPECIALTY_TEXTS_URL = '/communication-preferences/texts/specialty-text-alerts';

export const EDIT_PHARMACY_NOTIFICATIONS_URL = '/retail-rx-preferences-v2';

export const AUTOMATED_CALLS_URL = '/communication-preferences/automated-calls';

export const PHARMACY_CALLS_URL = '/communication-preferences/automated-calls/pharmacy-calls';

export const CAREMARK_CALLS_URL = '/communication-preferences/automated-calls/caremark-calls';

export const EMAILS_URL = '/communication-preferences/emails';

export const EMAIL_ALERTS_URL = '/communication-preferences/emails/email-alerts';

export const SPECIALTY_EMAIL_URL = '/communication-preferences/emails/specialty';

export const CAREMARK_EMAIL_URL = '/communication-preferences/emails/caremark';

export const PHARMACY_EMAILS_URL = '/communication-preferences/emails/rx-subscriptions';

export const EXTRACARE_EMAILS_URL = '/communication-preferences/emails/extracare';

export const H100_EMAILS_URL = '/communication-preferences/emails/health100';

export const MAIL_URL = '/communication-preferences/mail';

export const EXTRACARE_MAIL_URL = '/communication-preferences/mail/extracare-mail';

export const ERROR_PAGE_URL = '/communication-preferences/error';

export const UNAUTHENTICATED_STATUS_CODES = ['1001', '1005', '1006', '1007', '1008', '1009', '1011'];
